export const BASE_CLASS = 'mt-PanelPriceIndicator'

const IDS_MAPPING = {
  OVER_PRICED: 1,
  HIGH_EXPENSE: 2,
  FAIR_VALUE: 3,
  GOOD_VALUE: 4,
  SUPER_VALUE: 5
}

const DESCRIPTIONS = {
  OVER_PRICED: 'superior',
  HIGH_EXPENSE: 'ligeramente superior',
  FAIR_VALUE: 'igual o muy similar',
  GOOD_VALUE: 'ligeramente inferior',
  SUPER_VALUE: 'inferior'
}

export const COLORS = {
  GREEN: 'green',
  RED: 'red',
  YELLOW: 'yellow'
}

const POSITIONS = {
  FIFTH: 'fifth',
  FOURTH: 'fourth',
  THIRD: 'third',
  SECOND: 'second',
  FIRST: 'first'
}

const LABELS = {
  OVER_PRICED: 'Precio alto',
  HIGH_EXPENSE: 'Precio elevado',
  FAIR_VALUE: 'Precio justo',
  GOOD_VALUE: 'Buen precio',
  SUPER_VALUE: 'Super precio'
}

export const DEFAULT_PRICE_INDICATOR_CONFIG = {
  DESCRIPTION:
    'El precio es <strong>%{desciption}</strong> al valor de mercado basado en la tasación de coches.net. Comparación con coches similares de un/a vendedor/a profesional.',
  RANKS: {
    [IDS_MAPPING.OVER_PRICED]: {
      COLOR: COLORS.RED,
      DESCRIPTION: DESCRIPTIONS.OVER_PRICED,
      LABEL: LABELS.OVER_PRICED,
      POSITION: POSITIONS.FIFTH
    },
    [IDS_MAPPING.HIGH_EXPENSE]: {
      COLOR: COLORS.YELLOW,
      DESCRIPTION: DESCRIPTIONS.HIGH_EXPENSE,
      LABEL: LABELS.HIGH_EXPENSE,
      POSITION: POSITIONS.FOURTH
    },
    [IDS_MAPPING.FAIR_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: DESCRIPTIONS.FAIR_VALUE,
      LABEL: LABELS.FAIR_VALUE,
      POSITION: POSITIONS.THIRD
    },
    [IDS_MAPPING.GOOD_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: DESCRIPTIONS.GOOD_VALUE,
      LABEL: LABELS.GOOD_VALUE,
      POSITION: POSITIONS.SECOND
    },
    [IDS_MAPPING.SUPER_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: DESCRIPTIONS.SUPER_VALUE,
      LABEL: LABELS.SUPER_VALUE,
      POSITION: POSITIONS.FIRST
    }
  },
  FAQS: [
    'La valoración del precio de coches.net es totalmente neutral y no puede estar patrocinada.',
    'A parte de la marca, modelo y versión, el indicador de precio tiene en cuenta la antigüedad, kilometraje, potencia, combustible y otras características técnicas, a la vez que detalles de la localización del vehículo. Los extras adicionales a la versión, el estado del vehículo y la descripción no se tienen en consideración.',
    'Te recomendamos que revises todos los extras y la descripción que te ofrece el/la vendedor/a para obtener más información.'
  ]
}

const NEW_VEHICLE_DESCRIPTIONS = {
  OVER_PRICED: 'superior',
  HIGH_EXPENSE: 'ligeramente superior',
  FAIR_VALUE: 'ligeramente inferior',
  GOOD_VALUE: 'inferior',
  SUPER_VALUE: 'sustancialmente inferior'
}

const RENTING_DESCRIPTIONS = NEW_VEHICLE_DESCRIPTIONS

const NEW_VEHICLE_PRICE_INDICATOR_CONFIG = {
  DESCRIPTION: 'El precio es <strong>%{desciption}</strong> al precio oficial de la marca.',
  RANKS: {
    [IDS_MAPPING.OVER_PRICED]: {
      COLOR: COLORS.RED,
      DESCRIPTION: NEW_VEHICLE_DESCRIPTIONS.OVER_PRICED,
      LABEL: LABELS.OVER_PRICED,
      POSITION: POSITIONS.FIFTH
    },
    [IDS_MAPPING.HIGH_EXPENSE]: {
      COLOR: COLORS.YELLOW,
      DESCRIPTION: NEW_VEHICLE_DESCRIPTIONS.HIGH_EXPENSE,
      LABEL: LABELS.HIGH_EXPENSE,
      POSITION: POSITIONS.FOURTH
    },
    [IDS_MAPPING.FAIR_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: NEW_VEHICLE_DESCRIPTIONS.FAIR_VALUE,
      LABEL: LABELS.FAIR_VALUE,
      POSITION: POSITIONS.THIRD
    },
    [IDS_MAPPING.GOOD_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: NEW_VEHICLE_DESCRIPTIONS.GOOD_VALUE,
      LABEL: LABELS.GOOD_VALUE,
      POSITION: POSITIONS.SECOND
    },
    [IDS_MAPPING.SUPER_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: NEW_VEHICLE_DESCRIPTIONS.SUPER_VALUE,
      LABEL: LABELS.SUPER_VALUE,
      POSITION: POSITIONS.FIRST
    }
  },
  FAQS: [
    'La valoración del precio de coches.net es totalmente neutral y no puede estar patrocinada.',
    'Consideramos el valor oficial de la marca frente al precio del anuncio. Los detalles de la localización del vehículo, los extras adicionales a la versión y la descripción no se tienen en consideración.',
    'Te recomendamos que revises todos los extras y la descripción que te ofrece el/la vendedor/a para obtener más información.'
  ]
}
const RENTING_PRICE_INDICATOR_CONFIG = {
  DESCRIPTION: 'El precio es <strong>%{desciption}</strong> comparado con vehículos similares.',
  RANKS: {
    [IDS_MAPPING.OVER_PRICED]: {
      COLOR: COLORS.RED,
      DESCRIPTION: RENTING_DESCRIPTIONS.OVER_PRICED,
      LABEL: LABELS.OVER_PRICED,
      POSITION: POSITIONS.FIFTH
    },
    [IDS_MAPPING.HIGH_EXPENSE]: {
      COLOR: COLORS.YELLOW,
      DESCRIPTION: RENTING_DESCRIPTIONS.HIGH_EXPENSE,
      LABEL: LABELS.HIGH_EXPENSE,
      POSITION: POSITIONS.FOURTH
    },
    [IDS_MAPPING.FAIR_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: RENTING_DESCRIPTIONS.FAIR_VALUE,
      LABEL: LABELS.FAIR_VALUE,
      POSITION: POSITIONS.THIRD
    },
    [IDS_MAPPING.GOOD_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: RENTING_DESCRIPTIONS.GOOD_VALUE,
      LABEL: LABELS.GOOD_VALUE,
      POSITION: POSITIONS.SECOND
    },
    [IDS_MAPPING.SUPER_VALUE]: {
      COLOR: COLORS.GREEN,
      DESCRIPTION: RENTING_DESCRIPTIONS.SUPER_VALUE,
      LABEL: LABELS.SUPER_VALUE,
      POSITION: POSITIONS.FIRST
    }
  },
  FAQS: [
    'La valoración del precio de coches.net es totalmente neutral y no puede estar patrocinada.',
    'Evaluamos el valor del vehículo basándonos en el precio oficial de la marca al contado, comparándolo con el precio de la cuota de renting.',
    'No consideramos detalles sobre servicios adicionales o extras incluidos. Para obtener más información sobre servicios adicionales y características específicas, te recomendamos consultar directamente con el/la vendedor/a para obtener más información.'
  ]
}

/** Temporary config until migration of this component */
const OFFER_TYPE_NEW = 1
const OFFER_TYPE_SUBSCRIPTION = 10

export const PRICE_INDICATOR_CONFIG_BY_OFFER_TYPE = {
  [OFFER_TYPE_NEW]: NEW_VEHICLE_PRICE_INDICATOR_CONFIG,
  [OFFER_TYPE_SUBSCRIPTION]: RENTING_PRICE_INDICATOR_CONFIG
}
